import styled from 'styled-components';

export const Container = styled.div`
  margin-top: 2rem;
`;

export const Alert = styled.div`
  margin-top: 1.5rem;
`;
